import { render, staticRenderFns } from "./Screening.vue?vue&type=template&id=442024fa&scoped=true&"
import script from "./Screening.vue?vue&type=script&lang=js&"
export * from "./Screening.vue?vue&type=script&lang=js&"
import style0 from "./Screening.vue?vue&type=style&index=0&id=442024fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "442024fa",
  null
  
)

export default component.exports